const DEFAULT_TRACKING_HOSTS = ['formula55.tj', '55winers.com'];

export function isTrackingHost(hostname: string, hosts: string[] = DEFAULT_TRACKING_HOSTS): boolean {
  const host = hostname.trim().toLowerCase();
  return host !== '' && hosts.some((allowed) => host === allowed || host.endsWith(`.${allowed}`));
}
